import React from 'react'
import { connect } from 'react-redux'
import FormView from '../Main/PreviewView/FormView'

export default connect(
  (state) => ({
    viewSelected: state.signupForm.addOrEdit.previewResponseView,
  }),
  null,
)(({ viewSelected }) => <FormView />)
